import { render, staticRenderFns } from "./PhotoDialog.vue?vue&type=template&id=537e1f19&scoped=true&"
import script from "./PhotoDialog.vue?vue&type=script&lang=js&"
export * from "./PhotoDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhotoDialog.vue?vue&type=style&index=0&id=537e1f19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e1f19",
  null
  
)

export default component.exports